import React from 'react';
import Checkbox from '../Checkbox';

/**
 * Checkbox/Medium — Figma 4109:376
 * 24px selector · title `typo-h5` · description `typo-body-sm`.
 */
const CheckboxMedium = (props) => <Checkbox {...props} size="medium" />;

export default CheckboxMedium;
